import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { destinationTextNodesAtom, workingIdMapAtom } from './atoms'
import React, { useMemo } from 'react'
import { Box, Button } from '@mui/material'
import { openNode } from '../../utility/TreeNavigation'
import { INode } from 'shared/types/tree'
import { Table } from 'shared/ui/Table/Table'

export function ReplacedTable() {
  const nodes = useAtomValue(destinationTextNodesAtom)
  const columns = useTableColumns()
  return (
    <Box>
      <Table
        title={`${nodes.length} Nodes With Destination Text`}
        columns={columns}
        items={nodes}
      />
    </Box>
  )
}

export function useTableColumns() {
  const idMap = useAtomValue(workingIdMapAtom)
  return useMemo(() => {
    return [
      {
        title: <strong>Node Title</strong>,
        width: 100,
        rowContent({ title }: INode) {
          return title
        },
      },
      {
        title: <strong>Node Type</strong>,
        width: 100,
        rowContent({ type }: INode) {
          return type
        },
      },
      {
        title: <strong>Open</strong>,
        width: 50,
        rowContent(node: INode) {
          return <Button onClick={() => openNode(node, idMap)}>Go</Button>
        },
      },
    ]
  }, [idMap])
}
